export const education = [
  {
    degree: "Bachelor of Arts (B.A)",
    field: "3rd Year",
    institution: "National University",
    year: "In Progress",
  },
];
